const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/PlanSelector.tsx';
import React from 'react';
import { FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Plan } from 'App/defs/types';
import { useIntl } from 'react-intl';
import textMap from '../translations';
import { css } from '@emotion/css';
import { colors } from '@cistec/common_web/defs/colors';

type planSelectorProps = {
    plans: any;
    plansAreLoading: boolean;
    onChange: (elem: SelectChangeEvent<string>) => void;
    planList: Plan[] | null;
    classes: any;
    defaultValue?: Plan | null;
};

const getMainContainerClass = () => ({
    labelStyle: css`
        color: ${colors.grey['600']};
    `,
    selectInput: css`
        display: flex;
        flex-basis: 100%;
        height: 44px;
        & > .MuiSelect-select {
            height: 75%;
        }
        & fieldset {
            top: 0;
        }
        & fieldset > legend {
            display: none;
        }
    `,
});

const PlanSelector = (props: planSelectorProps) => {
    const { plans, plansAreLoading, onChange, planList, classes } = props;
    const { formatMessage } = useIntl();

    const defaultValue: string = props.defaultValue ? props.defaultValue?.Icode : '';

    const mainContainer = getMainContainerClass();
    return (
        <Grid size={{ xs: 12, sm: 6 }}>
            <FormControl fullWidth classes={classes}>
                <Typography variant="body1" className={mainContainer.labelStyle}>
                    {formatMessage(textMap.selectArea)}&nbsp;*
                </Typography>
                <Select
                    variant={'outlined'}
                    labelId="labelPlanSelect"
                    id="planSelect"
                    onChange={onChange}
                    disabled={plans?.size === 0 || plansAreLoading}
                    label={formatMessage(textMap.selectArea)}
                    fullWidth
                    key={defaultValue} // used to make it possible to change the default value without warnings
                    defaultValue={defaultValue}
                    className={mainContainer.selectInput}
                >
                    {planList?.map(plan => (
                        <MenuItem key={plan.Icode} value={plan.Icode}>
                            <div className="lineClampText">{plan.name}</div>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
    );
};

export default PlanSelector;
